import type React from 'react';

import { FormField, FormHelp, Input, Label, Text, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { RECYCLING_PROCEDURES } from '../../../constants';
import PhoneInput from '../../Widgets/PhoneInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function RecyclingProcedure_v2({ section, setSectionValues }: Props): JSX.Element {
  function onContainerLocationChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.CONTAINER_LOCATION]: value,
    });
  }

  function onPickupScheduleChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.PICKUP_SCHEDULE]: value,
    });
  }

  function onServiceProviderChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER]: value,
    });
  }

  function onPhoneNumberChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER]: value,
    });
  }

  return (
    <>
      <Text textStyle="body-lg-bold">Recycling</Text>
      <FormField
        required
        css={{ marginTop: 'layout.tighter' }}
        label={<Label>Where are the containers located?</Label>}
        control={
          <Textarea
            onChange={onContainerLocationChange}
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.CONTAINER_LOCATION)}
            css={{ resize: 'vertical' }}
          />
        }
      />
      <FormField
        required
        css={{ marginTop: 'layout.tighter' }}
        label={<Label>What is the pickup schedule?</Label>}
        control={
          <Textarea
            onChange={onPickupScheduleChange}
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.PICKUP_SCHEDULE)}
            css={{ resize: 'vertical' }}
          />
        }
      />
      <FormField
        required
        css={{ marginTop: 'layout.tighter' }}
        label={<Label>What service provider?</Label>}
        control={
          <Input
            onChange={onServiceProviderChange}
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER)}
          />
        }
      />
      <FormField
        required
        css={{ marginTop: 'layout.tighter' }}
        label={<Label>What is the provider’s phone number?</Label>}
        control={
          <PhoneInput
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)}
            onChange={onPhoneNumberChange}
            error={section.getField(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)?.hasError}
          />
        }
        description={
          section.getField(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)?.hasError && (
            <FormHelp>
              {section.getField(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)?.getErrorMessage()}
            </FormHelp>
          )
        }
      />
    </>
  );
}
